<!--  For Desktop only   -->
@if (!isMobileScreen) {
  <header>
    <div class="vtz-primary-header">
      @if(about.VWAFlowType === 'GLOBAL') {
        @if(about.headerImageUrl()) {
          <img src={{about.headerImageUrl()}} class="vtz-primary-header__img" alt="Customer image Header"
          i18n-alt="logo alt-text" />
        }
      } 
      @else {
        <!-- Insert customer logo. -->
        <img src="/assets/images/logo.svg" class="vtz-primary-header__img" alt="Voatz logo Header"
        i18n-alt="logo alt-text" />
      }
      <div class="vtz-primary-header__text-container">
        @if(title.length > 0) {
          <h1 id="vtz-h1" class="vtz-h2">{{title}}</h1>
        }
        @if(dates.length > 0) {
          <h2 id="vtz-h2" class="vtz-text vtz-text--small">{{dates}}</h2>
        }
      </div>
    </div>
  </header>
}

  <!--  For Mobile only   -->
  @if (isMobileScreen) {
    <header>
      <div class="header-container">
        <div class="header-row">
          <img src="/assets/images/logo.svg" alt="Voatz logo" class="voatz-image"  id="logo_voatz">
          @if(about.VWAFlowType === 'GLOBAL') {
            @if(about.headerImageUrl()) {
              <img src={{about.headerImageUrl()}} class="vtz-primary-header__img" alt="Customer image Header"
              i18n-alt="logo alt-text" />
            }
          } @else {
            <!-- Insert customer logo. -->
            <img src="/assets/images/logo_tzero.png"  class="customer-image" alt="Voatz logo"
              i18n-alt="logo alt-text" />
          }
          </div>
          <div class="header-row">
            <div class="header-col">
              @if(title.length > 0) {
                <h1 id="vtz-h1">{{title}}</h1>
              }
              @if(dates.length > 0) {
                <h2 id="vtz-h2">{{dates}}</h2>
              }
            </div>
          </div>
          <div class="header-row">
            <div class="header-button-container">
              <button mat-icon-button [matMenuTriggerFor]="menu" 
                  aria-label="Open support and navigation menu" 
                  aria-haspopup="true"
                  aria-expanded="false"
                  id="accessibility-button"
                  i18n-aria-label>
                <mat-icon style="color: #253E60;">menu</mat-icon>
               </button>
               <mat-menu #menu="matMenu">
                @if(sessionService.activeSessionCheck() && about.idUploadFlow) {
                  <button mat-menu-item (click)="gotoDashboard()"
                    aria-label="Return to the dashboard"
                    i18n-aria-label>
                    <mat-icon aria-hidden="true">dashboard</mat-icon>
                    <span i18n>Dashboard</span>
                  </button>
                }
                <a href="{{clientFAQ}}" target="_blank" rel="noopener noreferrer"
                  id="faq-button" 
                  mat-menu-item 
                  [attr.aria-label]="'FAQ - Opens in new window'"
                  i18n-aria-label>
                  <mat-icon aria-hidden="true">not_listed_location</mat-icon>
                  <span i18n>FAQ</span>
                </a>
                <a href="mailto:{{supportEmail}}" target="_blank" rel="noopener noreferrer" 
                  id="help-button" 
                  mat-menu-item 
                  [attr.aria-label]="'Contact Support - Opens email client'"
                  i18n-aria-label>
                  <mat-icon aria-hidden="true">contact_mail</mat-icon>
                  <span i18n>CONTACT SUPPORT</span>
                </a>
              </mat-menu>

              @if(routeName === "/home" || routeName === "/registration"  || routeName === "/welcome"){
                <app-language-drop-down ></app-language-drop-down>
              }       

              @if(!(routeName === "/home" || routeName === "/registration"  || routeName === "/welcome")){
                <app-user-menu></app-user-menu>
              }              
              

            </div>
          </div>
        </div>

      </header>
    }